module.exports = __webpack_public_path__ + "img/YZ02.a76a49c8.jpg";